export enum LogLevel {
    Trace = 'trce',
    Debug = 'dbug',
    Information = 'info',
    Warning = 'warn',
    Error = 'fail',
    Critical = 'crit',
    None = 'none'
}